import {
	deleteAction,
	getAction,
	postAction,
	putAction
} from '@/api/manage'

//角色管理
const addRole = (params) => postAction('/sys/role/add', params)
const editRole = (params) => putAction('/sys/role/edit', params)
const queryall = (params) => getAction('/sys/role/queryall', params)
const querySelectDeviceRecordItem = (id) => getAction('/om/device/record/item/selectDeviceRecordItem/' + id)
//用户管理
const addUser = (params) => postAction('/sys/user/add', params)
const addExtralUser = (params) => postAction('/sys/open/user', params)
const editUser = (params) => putAction('/sys/user/edit', params)
const editExtralUser = (params) => putAction('/sys/open/user', params)
const editUserParam = (params) => putAction('/sys/user/edit/param', params)
const getUserSite = (params) => getAction('/sys/user/queryUserSite', params)
const getOpenUserSite = (params) => getAction('/sys/open/user/queryUserSite', params)
const queryUserRole = (params) => getAction('/sys/user/queryUserRole', params)
const getUserList = (params) => getAction('/sys/user/list', params)
const queryUserTreeList = (params) => getAction('/sys/user/queryTreeList', params)
const frozenBatch = (params) => putAction('/sys/user/frozenBatch', params)
const querySysName = (params) => getAction('/sys/config/find/' + params)
const queryMapCenter = (params) => getAction('/sys/param/find/map/' + params)

const queryMapContent = (id) => getAction('/sys/param/find/'+id)
//改变密码
const changPassword = (params) => putAction('/sys/user/changPassword', params)
const getReplay = (params) => getAction('/online/st32/cn2061/replay', params)
//权限管理
const addPermission = (params) => postAction('/sys/permission/add', params)
const editPermission = (params) => putAction('/sys/permission/edit', params)
const getPermissionList = (params) => getAction('/sys/permission/list', params)
const queryTreeList = (params) => getAction('/sys/permission/queryTreeList', params)
const queryTreeListForRole = (params) => getAction('/sys/role/queryTreeList', params)
const queryRolePermission = (params) => getAction('/sys/permission/queryRolePermission', params)
const saveRolePermission = (params) => postAction('/sys/permission/saveRolePermission', params)
const queryPermissionsByUser = (params) => getAction('/sys/permission/getUserPermissionByToken', params)
const getPermissionRuleList = (params) => getAction('/sys/permission/getPermRuleListByPermId', params)
const queryPermissionRule = (params) => getAction('/sys/permission/queryPermissionRule', params)

// 部门管理
const queryDepartTreeList = (params) => getAction('/sysdepart/sysDepart/queryTreeList', params)
const queryIdTree = (params) => getAction('/sysdepart/sysDepart/queryIdTree', params)
const searchByKeywords = (params) => getAction('/sysdepart/sysDepart/searchBy', params)
const deleteByDepartId = (params) => deleteAction('/sysdepart/sysDepart/delete', params)

// 流域管理
const queryRiverTreeList = (params) => getAction('/sys/river/queryTreeList/1') // 查找有效状态
const queryRiverTreeListAll = (params) => getAction('/sys/river/queryTreeList/-1') // 查找全部

// 区域管理
const queryAreaTreeList = (params) => getAction('/sys/area/queryTreeList', params) // 默认查找全部  0：查找无效  1：查找有效

// 因子单位管理
const queryUnitList = (params) => getAction('/sys/factor/unit/list', params)

// 监测因子
const queryFactorList = (params) => getAction('/site/factor', params)

// 监测因子组指标
const queryFactorGroupItemList = (params) => getAction('/sys/factor/group/item/list', params)

// 环境标准
const queryStandardList = (params) => getAction('/site/standard', params)
const queryStandardTreeList = (params) => getAction('/site/standard/queryTreeList', params)
// 查询顶部导航栏
const queryTabList = (params) => getAction('/site/sys/type/getStCategory', params)
// 查询每个一张图对应的tab部分
const queryMapTab = (params) => getAction('/site/sys/type', params)
// 污水站点
const querySiteList = (params) => getAction('/site/info', params)
// 在线污水站点
const queryOnlineSiteInfoList = (params) => getAction('/site/info/online', params)
const querySiteById = () => getAction('/site/info/queryById')
const querySiteFactorById = (params) => getAction('/site/info/factor', params)
// 获取用户的租户id
const queryTenant = (params) => getAction('/tenant/user', params)
// 站点工艺点
const querySiteTechnologyList = (params) => getAction('/sys/site/technology/list', params)

// 知识库管理
const DocListByCategory = (params) => getAction('/sys/doc/listByCategory', params)

// 分类字典
const querySysCategoryTreeList = (params) => getAction('/sys/category/queryTreeList', params)

//数据字典
const addDict = (params) => postAction('/sys/dict/add', params)
const editDict = (params) => putAction('/sys/dict/edit', params)
const addDictItem = (params) => postAction('/sys/dictItem/add', params)
const editDictItem = (params) => putAction('/sys/dictItem/edit', params)

//字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params)


//字典标签专用（通过code获取字典数组）
export const ajaxGetScsDictItems = (code, params) => getAction(`/scs/dict/getDictItems/${code}`, params)

//系统通告
const doReleaseData = (params) => getAction('/sys/annountCement/doReleaseData', params)
const doReovkeData = (params) => getAction('/sys/annountCement/doReovkeData', params)


// 根据部门主键查询用户信息
const queryUserByDepId = (params) => getAction('/sys/user/queryUserByDepId', params)

// 查询用户角色表里的所有信息
const queryUserRoleMap = (params) => getAction('/sys/user/queryUserRoleMap', params)
// 重复校验
const duplicateCheck = (params) => getAction('/sys/duplicate/check', params)

const duplicateCheckData = (params) => getAction('/sys/duplicate/checkData', params)
// 取得所有的厂商目录
const queryAssetCompanyList = () => getAction('/device/company/findAll')


// 取得所有的产品参数列表
const queryProductParamList = (params) => getAction('/product/param/list', params)
// 取得所有的产品成分组成
const queryProductPartList = (params) => getAction('/product/parts/list', params)
//获取产品状态码信息
const queryProductStateList = (params) => getAction('/product/state/find/' + params)
// 根据ID查询产品信息
const queryProductById = (params) => getAction('/product/' + params)
//获取所有试剂信息
const queryReagentAll = (params) => getAction('/device/reagent', params)
//车辆使用登记List 车牌号下拉框
const queryEamsArchivesLicensePlate = () => getAction('/car/archives/queryTitle')
//车辆保险险种表格根据车辆档案Id查询
const queryCarInsuranceTypeList = (params) => getAction('/car/insurance/type/query/' + params)
//车辆事故险种格根据车辆档案Id查询
const queryCarAccidentRecordList = (params) => getAction('/car/repair/record/query/' + params)
// 查询站点在线状态
const queryOnlineById = (params) => getAction('/comm/online/' + params)

//设备档案 产品名称下拉框
const queryProductIdNameList = (params) => getAction('/product/queryName/' + params)
//设备档案 试剂名称下拉框
const queryReagentIdNameList = (params) => getAction('/device/reagent/queryName/' + params)
//设备档案设备名字
const queryDeviceNameList = () => getAction('/device/queryName')
//试剂更换 通过siteIds查询设备名称
const queryDeviceList = (params) => getAction('/device/query/' + params)
//标准物质名称下拉框
const queryMaterialsNameList = () => getAction('/device/materials/query')
//标准样更换 新增时更换标准物表格查询
const queryMaterialsList = (params) => getAction('/device/materials/queryName/' + params)

// 获取水质标准数据
const queryStand = (params) => getAction('/st21/cn2061/standardBySite?' + params)
const queryWasteStand = (params) => getAction('/online/st32/standardBySite', params)
const queryWaterStand = (params) => getAction('/online/st21/standardBySite', params)
const queryWastegasStand = (params) => getAction('/online/st31/standardBySite', params)
const queryWastesoilStand = (params) => getAction('/online/st35/standardBySite', params)
const queryYearWasteStand = (params) => getAction('/online/st32/responseYear', params)
// 获取空气标准数据
const querySkyStandBySite = (params) => getAction('/st22/cn2011/standardBySite?' + params)
const queryWasteSkyStandBySite = (params) => getAction('/st31/cn2011/standardBySite?' + params)

const queryWaterPoiBySite = (params) => getAction('/st21/cn3041/queryLngStrAndLatStr',params)
const queryWaterDataBySite = (siteId) => getAction('/st21/cn3041/queryNewRecord/' + siteId)

// 获取日报数据
const queryDateList = (params) => getAction('/st21/cn2061/realtime/', params)
// const queryWastDateList = (params) => getAction(`/online/nchky/api/realtime/`, params)
const queryWastDateList = (params) => getAction(`/online/st${params.st}/realtime/`, params)
// const queryWastDateList = (params) => getAction('/online/cn2011/realtime/', params)
const queryWastWaterDateList = (params,st=21) => getAction(`/online/st${st}/cn2061/`, params)
const queryRealWaterDateList = (params) => getAction('/online/st21/realtime/', params)
// 获取空气实时数据
const queryDateSkylist = (params) => getAction('/online/st22/cn2011/realtime/', params)
const queryDateSkyRealTime = (params) => getAction('/online/st22/realtime/', params)
const queryWastDateSkylist = (params) => getAction('/st31/cn2011/realtime/', params)
const queryHydrologylist = (params) => getAction('/st61/cn2011/realtime/', params)
// 获取水文对应曲线数据
const queryHydrologyAnalysislist = (params) => getAction('/st61/cn2011/analysis/rain/', params)
const queryHydrologyFlowlist = (params) => getAction('/st61/cn2011/analysis/flow/', params)
const queryHydrologyCapacitylist = (params) => getAction('/st61/cn2011/analysis/capacity/', params)
const queryHydrologyStagelist = (params) => getAction('/st61/cn2011/analysis/stage/', params)
// 获取空气aqi排名
const queryRankSkylist = (params) => getAction('/online/st22/rank/', params)
const queryWastRankSkylist = (params) => getAction('/st31/cn2011/rank/', params)
//获取水质日历数据
const queryReport = (params) => getAction('/st21/cn2061/report/', params)
const querWasteReport = (params) => getAction('/online/st32/report/', params)
const querWaterReport = (params) => getAction('/online/st21/report/', params)
const querSkyReport = (params) => getAction('/online/st22/report/', params)
const querWastegasReport = (params) => getAction('/online/st31/emissionsCalendar/', params)
const querWastesoilReport = (params) => getAction('/online/st35/report/', params)
//获取空气日历数据
const querySkyReport = (params) => getAction('/st22/cn2011/report/', params)
const queryWasteSkyReport = (params) => getAction('/st31/cn2011/report/', params)
const standardMonth = (params) => getAction('/online/st21/standardMonth/', params)
const skystandardMonth = (params) => getAction('/online/st22/standardMonth/', params)
const jxSkyStandardMonth = (params) => getAction('/online/nchky/api/standardMonth/', params)
const standardWasteMonth = (params) => getAction('/st32/cn2061/report/standardMonth/', params)
const standardSkyMonth = (params) => getAction('/st22/cn2011/report/standardMonth/', params)
const standardWasteSkyMonth = (params) => getAction('/st31/cn2011/report/standardMonth/', params)
//配（耗）件 通过deviceId加载配（耗）件
const queryPartsList = (params) => getAction('/site/parts/query/' + params)
//配（耗）件下拉框
const queryPartsNameList = () => getAction('/product/parts/queryName')

// 获取空气质量指数实时数据

//站点树
const querySiteTree = (params) => getAction('/online/env/api/queryTreeList', params)
// 站点信息
const querySiteBySt = (params) => getAction('/online/env/api/queryBySt', params)
// 环境一张图接口
const querySiteStand = (params) => getAction('/st21/cn2061/standard', params)
const queryWastSiteStand = (params) => getAction('/online/env/api/standardTotal', params)
// 获取空气标准数据
const querySkyStand = (params) => getAction('/st22/cn2011/standard', params)
const queryWastSkyStand = (params) => getAction('/st31/cn2011/standard', params)
// 曲线分析
const queryCurveAnalysis = (params) => getAction('/st21/cn2061/analysis/curve', params)
const queryWasteCurveAnalysis = (params) => getAction('/online/st32/chart', params)
const queryWastegasCurveAnalysis = (params) => getAction('/online/st31/chart', params)
const queryWastesoilCurveAnalysis = (params) => getAction('/online/st35/chart', params)
const queryEnergyAnalysis = (params) => getAction('/online/st54/chart', params)
const queryWaterCurveAnalysis = (params,st=21) => getAction(`/online/st${st}/chart`, params)
const querySkyCurveAnalysis = (params) => getAction('/online/st22/chart', params)
const queryWastehydrologyCurveAnalysis = (params) => getAction('/online/st61/chart', params)
const queryWastehydrologyPie = (params) => getAction('/online/st61/pie', params)
const querySkyPie = (params) => getAction('/online/st22/pie', params)
// 获取AQI数据曲线
const queryAqiAnalysis = (params) => getAction('/st22/cn2011/analysis/curve', params)
const queryWasteAqiAnalysis = (params) => getAction('/st31/cn2011/analysis/curve', params)
const queryElectricity = (params) => getAction('/st53/cn2011/electricity', params)
const queryElectri = (params) => getAction('/st53/cn2011', params)
// k线分析
const queryKlineAnalysis = (params) => getAction('/st21/cn2061/analysis/kline', params)
// 散点分析
const queryScatterAnalysis = (params) => getAction('/st21/cn2061/analysis/scatter', params)
// 虫洞分析
const queryRadarAnalysis = (params) => getAction('/st21/cn2061/analysis/radar', params)
// 同比分析
const querySameAnalysis = (params) => getAction('/st21/cn2061/analysis/same', params)
// 环比分析
const queryChainAnalysis = (params) => getAction('/st21/cn2061/analysis/chain', params)

// 耗能统计趋势图
const queryCarExpendDrawer = (params) => getAction('/car/use/list', params)
// 获取站点具体信息
const queryBigDataById = (params) => getAction('/online/env/api/queryBigDataById', params)
//加载文件
const queryFileList = (src, srcId) => getAction('/sys/common/file/queryFile/' + src + '/' + srcId)
// 在线预警
const queryWarn = (params) => getAction('/online/warn', params)
// 大屏预警接口
const queryScreenWarn = (params) => getAction('/online/warn/queryWarn', params)
// 在线工况
const queryRealtime = (params) => getAction('/st53/cn2011/realtime', params)
// ?type=1&id=7
// 试剂更换 新增时试剂表格查询
const queryReagentNameList = (params) => getAction('/site/reagent/queryReagent/' + params)
// 试剂、标准物、配（耗）件质更换 编辑时查询试剂表格
const queryReplaceList = (params) => getAction('/site/replace/queryReagent', params)

//车辆实时定位
const queryLocationList = (params) => getAction('/car/location/login/' + params)
//车辆历史轨迹
const queryTrajectoryList = (params) => getAction('/car/location/trajectory', params)
//车辆查询
const queryCarList = () => getAction('/car/archives/queryCarList')
//车辆登记查询
const queryCarRegisterList = (params) => getAction('/car/archives/queryCarRegisterList/' + params)

//巡检相关
//+巡检点位point和内容item http://localhost:3000/env/inspection/record/point/tree/1
const queryInspectionTree = (params) => getAction('om/inspection/record/point/tree/' + params)
//根据类型查询站点
const querySiteListByType = (params) => getAction('/inspection/recordinfo/queryByType/' + params)
//查询查询附件列表
const queryRecordInfoFileById = (params) => getAction('/inspection/recordinfo/queryFileById', params)
//巡检计划级联巡检模板获取模板名字
const queryTemplateTowList = (params) => getAction('om/inspection/template', params)
//预警曲线
const warnAnalysis = (params) => getAction('/st21/warn/analysis', params)
// 水质主要污染物
const queryPollution = (params) => getAction('/st21/warn/factorTotal', params)
const querywastePollution = (params) => getAction('/online/warn/factorTotal', params)
//预警曲线
const queryWarnAnalysis = (params) => getAction('/st21/warn/analysis', params)
//联网数据
const querySiteInfo = (params) => getAction('/online/env/api/bigDataOnline', params)

//联网数据
const mainRealtime = (params) => getAction('/st53/cn2011/mainRealtime', params)

//绍兴 曲线
const queryCurveAnalysisSx = (params) => getAction('/st53/cn2011/analysis/curve', params)
//用户所属部门查询
const queryUserTree = (params) => getAction('/sysdepart/sysDepart/queryUserTree/' + params)
//车辆状态查询
const queryCarStatus = (params) => getAction('/eams/car/archives/queryCarStatus/' + params)
// 视频列表
const queryLiveVideo = (params) => getAction('/site/live/device', params)
// 视频监控tree
const surveillanceTree = () => getAction('/online/video/surveillance/tree')
// 视频监控模糊查询
const selectVideos = (params) => getAction('/online/video/surveillance/selectVideos', params)
// 根据场景查站点
const sceneQueryById = (params) => getAction('/scene/queryBySceneId/' + params)
// 场景新增站点
const sceneAdd = (params) => postAction('/scene/add', params)
// 根据站点查预览路径
const queryUrlBySiteId = (params) => getAction('/scene/queryUrlBySiteId/' + params)

// 站点因子查询
const querySiteFactorBySiteId = (params) => getAction('/ea/asset/equipment/querySiteDeviceFactor/' + params)
// 站点分类
const statisticsSiteCategory = (params) => getAction('/site/info/statisticsSiteCategory', params)
// 设计处理能力
const st52ParamStatistics = (params) => getAction('/site/info/param/st52ParamStatistics', params)
// 七日预警统计
const statisticsWarnNum = (params) => getAction('/online/warn/statisticsWarnNum', params)
// 污水生产日报
const sumSt52Quota = (params) => getAction('/st52/quota/sumSt52Quota', params)
// 区域统计数据
const groupSt52Quota = (params) => getAction('/st52/quota/groupSt52Quota', params)
// 人工统计达标率
const siteStandardTotal = (params) => getAction('/online/manual/check/siteStandardTotal', params)
// 区域柱状曲线图数据
const siteStandardOnlineByArea = (params) => getAction('/online/manual/check/siteStandardOnlineByArea', params)
// 运维人员巡检动态
const queryAttendanceUserLast = (params) => getAction('/om/attendance/info/queryUserLast', params)
// 地图巡检站点人员信息
const queryAttendanceSiteLast = (params) => getAction('/om/inspection/record/querySiteLast', params)
const generateDayReport = (params) => getAction('/om/inspection/record/generateDayReport', params)
// 巡检分析
const queryInspectionAnalysis = (params) => getAction('/operation/statistical/queryInspectionAnalysis', params)
// 故障分析
const queryEquipmentFaultAnalysis = (params) => getAction('/operation/statistical/queryEquipmentFaultAnalysis', params)
// 预警分析
const queryWarningAnalysis = (params) => getAction('/operation/statistical/queryWarningAnalysis', params)
// 工单分析
const queryJobOrderAnalysis = (params) => getAction('/operation/statistical/queryJobOrderAnalysis', params)
// 运维统计
const getOperationStatistical = (params) => getAction('/operation/statistical/getOperationStatistical', params)
// 运维考评
const queryEvaluationAnalysis = (params) => getAction('/operation/statistical/queryEvaluationAnalysis', params)
// 设备仪表统计
const getAssetInfoStatistical = (params) => getAction('/ea/asset/info/static', params)
// ai今日事件
const queryTodayEvent = (params) => getAction('/ai/face/queryTodayEvent', params)
// ai人脸识别统计
const queryFace = (params) => getAction('/ai/face/queryFace', params)
// ai区域告警统计
const queryAreaAlarm = (params) => getAction('/ai/face/queryAreaAlarm', params)
// ai识别列表
const queryFaceList = (params) => getAction('/ai/face/queryFaceList', params)
// ai站点
const queryMapEventList = (params) => getAction('/ai/face/queryMapEventList', params)
// st租户
const getTenantStByToken = (params) => getAction('/sys/tenant/getTenantStByToken', params)
// 租户信息
const getTenantInfo = (tenantCode, params) => getAction(`/sys/tenant/name/${tenantCode}`, params)
// 获取区域站点 以及中心点
const queryAreaTodayEvent = (params) => postAction('/sys/area/queryTodayEvent', params)
// 分配区域管理员
const setAreaDistribution = (params) => postAction('/sys/area/distribution', params)
// 查询区域管理员
const getAreaUser = (params) => getAction('/sys/area/distribution/' + params)
// 地图获取区域详情
const queryAreaInfo = (params) => getAction('/sys/area/' + params)
// 新增运维计划
const workPlanAddBatch = (params) => postAction('/om/work/plan/addBatch', params)
const getWorkPlanTypes = () => getAction('/om/work/plan/types')
// 完成工作计划项目
const completeWorkPlanDetail = (params) => postAction('/om/work/plan/detail/complete', params)
// 门禁
const entranceGuard = (params) => getAction('/sys/entrance/guard/querySiteDeviceBan/' + params)

//运维日报 - 巡检总条数查询
const queryInspectionList = (params) => getAction('/inspection/report/generate/items/' + params)
//运维日报 - 删除单条巡检记录
const delInspectionItem = (params) => deleteAction('/inspection/report/record/delInspectionItem', params)
// 查询已绑定场景的站点id
const querySelectSiteIds = (params) => getAction('/scene/querySelectSiteIds/' + params)
// 查询管网列表
const queryPipeSystem = (params) => getAction('/sys/pipe/system', params)
// 查询窨井盖列表
const queryManholeCover = (params) => getAction('/sys/manhole/cover', params)
// 站点在线状态统计
const onlineStatistics = (params) => getAction('/online/nchky/api/onlineStatistics/' + params)

// 江西部分获取map的饼图部分
const siteMapVocs = (params) => getAction(`/online/nchky/api/siteMapVocs?siteId=` + params)

// 青岛获取aqi接口
const mojiAqi = (params) => getAction(`/sys/moji/condition`, params)
const mojiForecast = (params) => getAction('/sys/moji/forecast15days',params)

//巡检单考评统计饼图
const inspectionEvaluationScore = (params) => getAction(`/om/inspection/record/inspectionEvaluationStar`, params)
//巡检单考评统计折线图
const EvaluationLineChart = (params) => getAction(`/om/inspection/record/evaluationStarValue`, params)
//巡检单巡检统计饼图
const PatrolStatistics = (params) => getAction(`/om/inspection/record/evaluationStarCompare`, params)
//巡检单巡检对比图
const AverageStarValue = (params) => getAction(`/om/inspection/record/inspectionStatistics`, params)
//派工单考评统计饼图
const DispatchStatisticsChart = (params) => getAction(`/om/job/order/jobEvaluationStar`, params)
//派工单考评统计折线图
const evaluationStatisticsChart = (params) => getAction(`/om/job/order/jobEvaluationStarValue`, params)
//派工单巡检统计饼图
const DispatchRoutingChart = (params) => getAction(`/om/job/order/evaluationStarCompare`, params)
//派工单巡检对比图
const DispatchComparisonDiagram = (params) => getAction(`/om/job/order/JovStatistics`, params)

//参数备案新增量程
const newRange = (params) => postAction('/om/parameter/filing', params)
//通过资产id查询所有量程和量程子表
const queryRange = (params) => getAction('/om/parameter/filing/queryRange/' + params)

//列表分页查询
const listQuery=(params) => getAction('/om/day/quality/control/' , params)
//该站点下所匹配的检测因子
const queryFactorModel=(params) => getAction('/om/day/quality/control/queryFactorModel/' + params)
//查询单因子往期记录
const detectionFactor=(params)=> getAction('/om/day/quality/control/detectionFactor/' + params)
//日质控设置添加
const control=(params)=> postAction('/om/day/quality/control' , params)

//企业列表
const siteCompanyList=(params)=> getAction('/site/company' , params)

// TODO 未实现接口 临时修复
const getProductTreeList = (params) => getAction('/eams/product/category/listByProduct', params)
export {
  siteCompanyList,
	querySelectDeviceRecordItem,
	mojiAqi,
  mojiForecast,
	siteMapVocs,
	onlineStatistics,
	queryManholeCover,
	queryPipeSystem,
	querySelectSiteIds,
	entranceGuard,
	workPlanAddBatch,
	getWorkPlanTypes,
	completeWorkPlanDetail,
	queryAreaInfo,
	getAreaUser,
	setAreaDistribution,
	queryAreaTodayEvent,
	getTenantStByToken,
  getTenantInfo,
	queryMapEventList,
	queryFaceList,
	queryAreaAlarm,
	queryFace,
	queryTodayEvent,
	queryEvaluationAnalysis,
	getAssetInfoStatistical,
	getOperationStatistical,
	queryJobOrderAnalysis,
	queryWarningAnalysis,
	queryEquipmentFaultAnalysis,
	queryAttendanceSiteLast,
	generateDayReport,
	queryAttendanceUserLast,
	queryInspectionAnalysis,
	siteStandardOnlineByArea,
	siteStandardTotal,
	groupSt52Quota,
	sumSt52Quota,
	statisticsSiteCategory,
	st52ParamStatistics,
	statisticsWarnNum,
	sceneQueryById,
	sceneAdd,
	queryUrlBySiteId,
	queryTabList,
	queryMapTab,
	getReplay,
	queryHydrologyFlowlist,
	queryHydrologyCapacitylist,
	queryHydrologyStagelist,
	queryHydrologyAnalysislist,
	queryWastRankSkylist,
	queryWastDateSkylist,
	queryHydrologylist,
	queryWastSkyStand,
	queryWastDateList,
	queryWastWaterDateList,
	queryRealWaterDateList,
	queryWastSiteStand,
	queryRankSkylist,
	querySkyStandBySite,
	queryWasteSkyStandBySite,
  queryWaterPoiBySite,
  queryWaterDataBySite,
	standardSkyMonth,
	standardWasteSkyMonth,
	querySkyReport,
	queryWasteSkyReport,
	querySkyStand,
	queryAqiAnalysis,
	queryWasteAqiAnalysis,
	queryDateSkylist,
	queryDateSkyRealTime,
	standardMonth,
	skystandardMonth,
	jxSkyStandardMonth,
	standardWasteMonth,
	queryCurveAnalysisSx,
	queryUserTree,
	queryCarStatus,
	queryStand,
	queryWasteStand,
	queryWaterStand,
	queryWastegasStand,
	queryWastesoilStand,
	queryYearWasteStand,
	queryReport,
	querWasteReport,
	querWaterReport,
	querSkyReport,
	querWastegasReport,
	querWastesoilReport,
	queryBigDataById,
	queryPollution,
	querywastePollution,
	queryDateList,
	querySiteStand,
	querySiteTree,
	querySiteBySt,
	addRole,
	editRole,
	addUser,
	addExtralUser,
	editUser,
	editExtralUser,
	querySysName,
	queryUserRole,
	getUserList,
	queryUserTreeList,
	queryMapCenter,
  queryMapContent,
	queryall,
	frozenBatch,
	changPassword,
	getPermissionList,
	addPermission,
	editPermission,
	queryTreeList,
	queryRolePermission,
	saveRolePermission,
	queryPermissionsByUser,
	getPermissionRuleList,
	queryPermissionRule,
	queryDepartTreeList,
	queryRiverTreeList,
	queryRiverTreeListAll,
	queryAreaTreeList,
	queryUnitList,
	queryFactorList,
	queryFactorGroupItemList,
	queryStandardList,
	queryStandardTreeList,
	querySiteList,
	queryOnlineSiteInfoList,
	querySiteTechnologyList,
	DocListByCategory,
	queryIdTree,
	searchByKeywords,
	deleteByDepartId,
	querySysCategoryTreeList,
	addDict,
	editDict,
	addDictItem,
	editDictItem,
	doReleaseData,
	doReovkeData,
	queryUserByDepId,
	queryUserRoleMap,
	duplicateCheck,
  duplicateCheckData,
	queryTreeListForRole,
	queryAssetCompanyList,
	queryProductParamList,
	queryProductPartList,
	queryProductStateList,
	queryProductById,
	querySiteById,
	querySiteFactorById,
	queryTenant,
	queryEamsArchivesLicensePlate,
	queryCarInsuranceTypeList,
	queryCarAccidentRecordList,
	queryOnlineById,
	queryProductIdNameList,
	queryReagentIdNameList,
	queryCurveAnalysis,
	queryWasteCurveAnalysis,
	queryWastesoilCurveAnalysis,
  queryEnergyAnalysis,
	queryWaterCurveAnalysis,
	querySkyCurveAnalysis,
	queryWastehydrologyCurveAnalysis,
	queryWastehydrologyPie,
	querySkyPie,
	queryWastegasCurveAnalysis,
	queryKlineAnalysis,
	queryScatterAnalysis,
	queryRadarAnalysis,
	querySameAnalysis,
	queryChainAnalysis,
	queryCarExpendDrawer,
	queryFileList,
	queryDeviceNameList,
	queryDeviceList,
	queryMaterialsNameList,
	queryPartsList,
	queryPartsNameList,
	queryReagentNameList,
	queryRealtime,
	queryReplaceList,
	queryMaterialsList,
	queryReagentAll,
	queryElectricity,
	queryElectri,
	queryLocationList,
	queryTrajectoryList,
	queryCarList,
	queryCarRegisterList,
	queryInspectionTree,
	querySiteListByType,
	queryRecordInfoFileById,
	queryTemplateTowList,
	warnAnalysis,
	queryWarnAnalysis,
	querySiteInfo,
	mainRealtime,
	editUserParam,
	getUserSite,
	getOpenUserSite,
	queryLiveVideo,
	surveillanceTree,
	selectVideos,
	queryWarn,
	queryScreenWarn,
	querySiteFactorBySiteId,
	queryInspectionList,
	delInspectionItem,
	inspectionEvaluationScore,
	EvaluationLineChart,
	PatrolStatistics,
	AverageStarValue,
	DispatchStatisticsChart,
	evaluationStatisticsChart,
	DispatchRoutingChart,
	DispatchComparisonDiagram,
	newRange,
	queryRange,
	listQuery,
	queryFactorModel,
	detectionFactor,
	control
}
